import {Application} from './application.model';

export class ApplicationProviderListModel extends Application {
    public pendingRequestCount: number;
    public syncMode: string;
    public nextExecutionDate: string;
    public lastExecutionDate: string;
    public lastExecutionStatus: number;
    public vendorName: string;
    public validationErrorsCount: number;
    public isNew: boolean;
    public isValidConnection: boolean;
    public integrationId: string;
    public generalErrorCount: number;
    public defaultSchemaName: string;
    public significantDeletePercent: number;
    public significantUpdatePercent: number;
    public isADAWApplication?: boolean;

    constructor(guid: string, name: string, expirationTs: Date, icon?: string, pendingRequestCount?: number, syncMode?: string,
        nextExecutionDate?: string, lastExecutionDate?: string, vendorName?: string, validationErrorsCount?: number,
        generalErrorCount?: number, isNew?: boolean, isValidConnection?: boolean, integrationId?: string, defaultSchemaName?: string) {
        super(guid, name, expirationTs);
        this.icon = icon;
        this.pendingRequestCount = pendingRequestCount;
        this.syncMode = syncMode;
        this.nextExecutionDate = nextExecutionDate;
        this.lastExecutionDate = lastExecutionDate;
        this.vendorName = vendorName;
        this.validationErrorsCount = validationErrorsCount;
        this.generalErrorCount = generalErrorCount;
        this.isNew = isNew;
        this.isValidConnection = isValidConnection;
        this.integrationId = integrationId;
        this.defaultSchemaName = defaultSchemaName;
    }
}
